import React from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { HelpBlock } from "components/bootstrap";
import OperatorField from "data-lake/preview/OperatorField";
import FieldFiltersConfiguration from "data-lake/FieldFiltersConfiguration/FieldFiltersConfiguration";
import StyledLabel from "data-lake/components/DataLakeActionModals/StyledLabel";
const FieldsFiltersField = () => {
  const { t } = useTranslation("enterprise_data_lake");
  const {
    values: { fieldFilters }
  } = useFormikContext();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledLabel, null, t("fields_filter.label")), /* @__PURE__ */ React.createElement(HelpBlock, null, t("fields_filter.help")), !!fieldFilters.length && /* @__PURE__ */ React.createElement(OperatorField, null), /* @__PURE__ */ React.createElement(FieldFiltersConfiguration, { maxFilters: 3 }));
};
export default FieldsFiltersField;
